import PropTypes from 'prop-types';

export const blogCardPropTypes = {
  /**
   * The URL of the image to display in the card.
   * @type {string}
   */
  image: PropTypes.string,
  /**
   * The title of the card.
   * @type {string}
   * @required
   */
  title: PropTypes.string.isRequired,
  /**
   * The main content of the card.
   * @type {string}
   * @required
   */
  content: PropTypes.string.isRequired,
  /**
   * The elevation level of the card.
   * @type {number}
   */
  elevation: PropTypes.number,
  /**
   * Alternative text to provided image.
   * @type {string}
   */
  imageAlt: PropTypes.string,
  /**
   * Background color for the blog card.
   * Can be a valid CSS color string or one of the theme colors: 'primary', 'secondary'.
   */
  backgroundColor: PropTypes.oneOfType([
    PropTypes.oneOf(['primary', 'secondary']),
    PropTypes.string,
  ]),
  /** Optional action element to render at the bottom of the card. */
  action: PropTypes.node,
};

export const blogCardDefaultProps = {
  width: '360px',
  elevation: 0,
  backgroundColor: 'transparent',
};
